export function validateEmail(email: string): boolean {
    // pulled from https://www.regular-expressions.info/email.html
    const isEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return isEmail.test(email);
}
